var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mbo-obs"},[_c('MbOverlayStage',[_c('MbOverlay',{attrs:{"scene":_vm.scene,"battle":_vm.battle,"post-battle":_vm.scene === 'post' ? _vm.battle : null,"events":_vm.events,"series":_vm.series}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }